'use strict';
import React from 'react';
import {Navigation} from 'react-router';
import t from 'tcomb-form';
import flux from 'utils/flux';
import store from 'store';
import Select from 'react-select';
import dom from 'utils/dom';

const hasAccountGroupList = window.accountGroupList && window.accountGroupList.length;

var Form = t.form.Form;

var RegisterModal = React.createClass({
    displayName: 'RegisterModal',
    mixins: [Navigation],
    propTypes: {
        hasError: React.PropTypes.oneOfType([
            React.PropTypes.string,
            React.PropTypes.bool
        ])
    },
    getInitialState() {
        const { acceptTermsCheckmark } = flux.getStore('app').getState().config.toJS();
        return {
            acceptedTerms: !acceptTermsCheckmark,
            registerSuccess: false,
            submitting: false,
            language: flux.getStore('translations').getUserLocale() || 'EN'
        };
    },
    _setInnerHtml(html) {
        return {__html: html};
    },
    componentWillReceiveProps(nextProps) {
        if (nextProps.hasError && this.state.submitting) {
            this.setState({submitting: false});
        }
    },
    onSubmit(evt) {
        evt.preventDefault();

        var registerData = this.refs.form.getValue();
        registerData.language = store.get('mediabox_user_language');

        if (registerData) {
            this.setState({
                submitting: true
            });
            flux.getStore('app').registerUser(registerData)
                .then(() => {
                    this.setState({
                        registerSuccess: true,
                        submitting: false
                    });
                })
                .catch(error => {
                    console.error(error);
                });
        }
    },
    renderError() {
        if (this.props.hasError) {
            return (
                <div className="content__error">
                    {this.props.hasError}
                </div>
            );
        }
    },
    onChange(value) {
        this.setState(value);
    },
    render() {
        const { acceptTermsCheckmark, mediaboxRights } = flux.getStore('app').getState().config.toJS();
        const { registerForm } = flux.getStore('app').getState();

        var RegisterFields = {};
        var fields = {};

        var selectTemplate = (values, placeholder) => (locals) => <div className="field">
            <label>{locals.label}</label>
            <Select
                name="country"
                placeholder={flux.t(placeholder)}
                options={values}
                value={locals.value}
                onChange={locals.onChange}
            />
            {locals.hasError ? <div className="field__error">{locals.error}</div> : ''}
        </div>;


        registerForm.forEach(row => {
            row.registerColumns.forEach(column => {
                column.registerFields.forEach(field => {
                    RegisterFields[field.name] = field.validationRequired ? t.Str : t.maybe(t.Str);
                    fields[field.name] = {
                        error: flux.t(field.errorKey),
                        label: flux.t(field.labelKey) + (field.validationRequired ? "*" : "")
                    }
                    if (field.type) {
                        fields[field.name]["type"] = field.type;
                    }
                    if (field.values.length > 0) {
                        var values = []
                        field.values.forEach(value => values.push({value: value.key, label: value.value}));
                        fields[field.name]["template"] = selectTemplate(values, field.errorKey);
                    }
                });
            });
        });
        var Register = t.struct(RegisterFields);
        if (this.state.registerSuccess) {
            return (
                mediaboxRights === 1 ?
                    <div className="register__success">

                        <h4 className="form__success">
                            {flux.t('register_success_title')}
                        </h4>
                        {flux.t('register_success_message')}
                    </div>
                    :
                    <div className="register__success">

                        <h4 className="form__success">
                            {flux.t('sign_up_new_user_success_title')}
                        </h4>
                        {flux.t('sign_up_new_user_success_message')}
                    </div>
            );
        }

        var options = {
            auto: 'labels',
            template: locals => {
                const {inputs} = locals;
                const inputList = [];
                for(let input in inputs) {
                    if (!inputs.hasOwnProperty(input)) continue;
                    inputList.push({name: input, input: inputs[input]});
                }
                const { registerForm } = flux.getStore('app').getState();
                return (
                    <div className="form__register">
                        {
                            registerForm.map(row => {
                                if (row.registerColumns.length == 0) {
                                    return (
                                        <div className="register__comment"><hr/></div>
                                    )
                                } if (row.registerColumns.length == 1) {
                                    return (
                                        <div className="register__comment">
                                            {row.registerColumns[0].registerFields[0] && inputs[row.registerColumns[0].registerFields[0].name]}
                                        </div>
                                    )
                                } else if(row.registerColumns.length > 1) {
                                    return (
                                        <div>
                                            <div className="register__left">
                                                {row.registerColumns[0].registerFields[0] && inputs[row.registerColumns[0].registerFields[0].name]}
                                            </div>
                                            <div className="register__right">
                                                {row.registerColumns[1].registerFields[0] && inputs[row.registerColumns[1].registerFields[0].name]}
                                            </div>
                                        </div>
                                    )
                                }
                            })
                        }
                        <div style={{clear: "both"}} className="register__tac">
                            <p className="text-light" dangerouslySetInnerHTML={dom.setInnerHtml(flux.t('terms_and_conditions'))}/>
                        </div>
                        <span className="register__hint">{flux.t('register_required_fields_text')}</span>
                    </div>);
            },
            fields: {
                ...fields,
                language: {
                    type: 'hidden'
                }
            }
        };

        return (
            <div>
                <h4>{flux.t('account_sign_up')}</h4>
                <form onSubmit={this.onSubmit}>
                    <Form
                        ref="form"
                        type={Register}
                        value={this.state}
                        options={options}
                        onChange={this.onChange}
                    />
                    {this.renderError()}
                    <hr className="white"/>
                    <div className="register__submit">
                        <button disabled={this.state.submitting} type="submit" className="btn btn-primary btn-arrow">
                            {flux.t('register_submit')}
                            <i className="chevron-right"/>
                        </button>
                    </div>
                    <div className="mejs-clear"/>
                </form>
            </div>
        );
    }
});

module.exports = RegisterModal;



// WEBPACK FOOTER //
// ./app/components/modals/registerModal.jsx